// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qiW5wnKZyjottKxtZNLmk{display:grid;grid-template-columns:repeat(3, 1fr);grid-gap:1.14286rem}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emoteList": "qiW5wnKZyjottKxtZNLmk"
};
export default ___CSS_LOADER_EXPORT___;
